define(['../fillLeadingZeroes'], function(fillLeadingZeroes) {
    return function(dt) {
        return dt.getUTCFullYear() + '-' + fillLeadingZeroes(dt.getUTCMonth() + 1, 2) + '-' + fillLeadingZeroes(dt.getUTCDate(), 2);
    };
});
